import { useNavigate } from 'react-router-dom';

import {
  createTripGroupFolder,
  createTripGroupJoin,
  deleteTripGroupFolders,
  deleteTripGroups,
  readTripGroupAnswers,
  readTripGroupFolders,
  readTripGroupItems,
  readTripGroupPrompts,
  shareTripGroupFoldersWithClient,
  shareTripGroupFoldersWithUsers,
  shareTripGroupsWithUsers,
  shareTripGroupWithClient,
  updateTripGroupFolder,
  updateTripGroupFolderName,
  updateTripGroupName,
} from '@api/trip_groups';

import ItemAnswers from '../../components/ItemAnswers';
import ListPage from '../../components/ListPage';

import AddToFolder from '../../components/ListPage/components/ActionsToolbar/components/AddToFolder';
import Copy from '../../components/ListPage/components/ActionsToolbar/components/Copy';
import Delete from '../../components/ListPage/components/ActionsToolbar/components/Delete';
import Join from '../../components/ListPage/components/ActionsToolbar/components/Join';
import Rename from '../../components/ListPage/components/ActionsToolbar/components/Rename';
import Share from '../../components/ListPage/components/ActionsToolbar/components/Share';

import { FILTER_OPTIONS, FOLDER_COLUMNS, ITEM_COLUMNS } from './utilities/helpers';

const TripGroups = () => {
  const navigate = useNavigate();

  return (
    <ListPage
      createFolder={createTripGroupFolder}
      filterOptions={FILTER_OPTIONS}
      folderActions={[
        <Rename
          key="rename-folder"
          type="Trip Group"
          updateName={({ name, row }) => updateTripGroupFolderName({ id: row.id, name })}
        />,
        <Share
          key="share-folder"
          shareWithClient={shareTripGroupFoldersWithClient}
          shareWithUsers={shareTripGroupFoldersWithUsers}
        />,
        <Delete
          deleteItems={(selectedRows) =>
            deleteTripGroupFolders({ ids: selectedRows.map(({ id }) => id) })
          }
          key="delete-folder"
        />,
      ]}
      folderColumns={FOLDER_COLUMNS}
      itemActions={[
        <Rename
          key="rename-item"
          type="Trip Group"
          updateName={({ name, row }) => updateTripGroupName({ id: row.id, name })}
        />,
        <Copy key="copy-item" redirect="/dashboard/create-trip-group" />,
        <AddToFolder
          createFolder={createTripGroupFolder}
          key="add-item-to-folder"
          readFolders={readTripGroupFolders}
          updateFolder={updateTripGroupFolder}
        />,
        <Join createJoin={createTripGroupJoin} key="join-item" name="trip_group" />,
        <Share
          key="share-item"
          shareWithClient={shareTripGroupWithClient}
          shareWithUsers={shareTripGroupsWithUsers}
        />,
        <Delete
          deleteItems={(selectedRows) =>
            deleteTripGroups({ ids: selectedRows.map(({ id }) => id) })
          }
          key="delete-item"
        />,
      ]}
      itemColumns={ITEM_COLUMNS}
      onCreate={() => navigate('/dashboard/create-trip-group')}
      readFolders={readTripGroupFolders}
      readItems={readTripGroupItems}
      renderRowExpanded={({ row }) => (
        <ItemAnswers
          item={row?.original}
          readItemAnswers={readTripGroupAnswers}
          readPrompts={readTripGroupPrompts}
          type="Trip Group"
        />
      )}
      type="Trip Group"
    />
  );
};

export default TripGroups;
